var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$store.getters.loggedIn && _vm.stempelkarteLoaded
      ? _c(
          "div",
          { staticClass: "stempelRahmen" },
          [
            _c(
              "div",
              { staticClass: "text-center mb-7" },
              [
                _vm.$store.getters.loggedIn
                  ? _c("div", [_vm._v("Deine aktuelle Stempelkarte")])
                  : _vm._e(),
                _c("StempelAnzahl"),
              ],
              1
            ),
            _c(
              "v-row",
              {},
              _vm._l(10, function (stempel) {
                return _c(
                  "v-col",
                  { staticClass: "pa-1", attrs: { cols: "3" } },
                  [
                    stempel <= _vm.stempelCounter
                      ? _c("div", { staticClass: "superCenter" }, [
                          _c("img", {
                            staticClass: "stempelImage",
                            attrs: {
                              src: require("../assets/loyalty/stempel.png"),
                            },
                          }),
                        ])
                      : _c("div", { staticClass: "superCenter" }, [
                          _c("div", { staticClass: "circle" }),
                        ]),
                  ]
                )
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.$store.getters.loggedIn && !_vm.stempelkarteLoaded
      ? _c(
          "div",
          [
            _c(
              "v-layout",
              { attrs: { row: "", wrap: "" } },
              _vm._l(1, function (n) {
                return _c(
                  "v-flex",
                  { attrs: { xs12: "" } },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "mx-auto",
                      attrs: { "max-width": "600", type: "image, article" },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }